/* eslint-disable jsx-a11y/label-has-associated-control */
import { Form } from 'semantic-ui-react';
import { useState } from '@wordpress/element';
import BarChart from './BarChart';
import data from '../data.json';

const HoldingBackBlacks = () => {
    const [racialDiscrimination, setRacialDiscrimination] = useState(
        'Major reason',
    );
    const [schools, setSchools] = useState('Major reason');
    const [family, setFamily] = useState('Major reason');
    const [discrimination, setDiscrimination] = useState(
        'Discrimination built into our laws and institutions',
    );

    return (
        <>
            <div className="content-box">
                <h3 id="holding-back">What may be holding blacks back?</h3>
                <section id="racial-discrimination">
                    <p>
                        When asked about the reasons why black people may have a
                        harder time getting ahead than whites, blacks are about
                        twice as likely as whites to say that racial
                        discrimination is a major factor holding black people
                        back. Large majorities of blacks across all demographic
                        groups say this. Among whites, Democrats and adults ages
                        18 to 29 are much more likely than their counterparts to
                        see discrimination as a major reason why blacks may have
                        a harder time getting ahead than whites.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            Racial discrimination is a ______ why black people
                            in our country may have a harder time getting ahead
                            than whites
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Major reason"
                                checked={
                                    'Major reason' === racialDiscrimination
                                }
                                value="Major reason"
                                onClick={() =>
                                    setRacialDiscrimination('Major reason')
                                }
                            />
                            <Form.Radio
                                label="Minor reason"
                                checked={
                                    'Minor reason' === racialDiscrimination
                                }
                                value="Minor reason"
                                onClick={() =>
                                    setRacialDiscrimination('Minor reason')
                                }
                            />
                            <Form.Radio
                                label="Not a reason"
                                checked={
                                    'Not a reason' === racialDiscrimination
                                }
                                value="Not a reason"
                                onClick={() =>
                                    setRacialDiscrimination('Not a reason')
                                }
                            />
                        </div>
                        {'Major reason' === racialDiscrimination && (
                            <BarChart data={data.majorReasonDiscrimination} />
                        )}
                        {'Minor reason' === racialDiscrimination && (
                            <BarChart data={data.minorReasonDiscrimination} />
                        )}
                        {'Not a reason' === racialDiscrimination && (
                            <BarChart data={data.notReasonDiscrimination} />
                        )}
                    </div>
                </section>
                <section id="lower-quality-schools">
                    <p>
                        Blacks are considerably more likely than whites to say
                        that lower quality schools are a major reason why black
                        people may have a harder time getting ahead than whites.
                        This is true regardless of gender, age, education and
                        party identification.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            Lower quality schools are a ______ why black people
                            in our country may have a harder time getting ahead
                            than whites
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Major reason"
                                checked={'Major reason' === schools}
                                value="Major reason"
                                onClick={() => setSchools('Major reason')}
                            />
                            <Form.Radio
                                label="Minor reason"
                                checked={'Minor reason' === schools}
                                value="Minor reason"
                                onClick={() => setSchools('Minor reason')}
                            />
                            <Form.Radio
                                label="Not a reason"
                                checked={'Not a reason' === schools}
                                value="Not a reason"
                                onClick={() => setSchools('Not a reason')}
                            />
                        </div>

                        {'Major reason' === schools && (
                            <BarChart data={data.majorReasonSchools} />
                        )}
                        {'Minor reason' === schools && (
                            <BarChart data={data.minorReasonSchools} />
                        )}
                        {'Not a reason' === schools && (
                            <BarChart data={data.notReasonSchools} />
                        )}
                    </div>
                </section>
                <section id="family-instability">
                    <p>
                        Across all major demographic groups, similar shares of
                        whites and blacks say family instability is a major
                        reason why black people may have a harder time getting
                        ahead than whites. The survey also asked about three
                        other possible reasons for achievement gaps: lack of
                        good role models, lack of jobs and lack of motivation to
                        work hard.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            Family instability is a ______ why black people in
                            our country may have a harder time getting ahead
                            than whites
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Major reason"
                                checked={'Major reason' === family}
                                value="Major reason"
                                onClick={() => setFamily('Major reason')}
                            />
                            <Form.Radio
                                label="Minor reason"
                                checked={'Minor reason' === family}
                                value="Minor reason"
                                onClick={() => setFamily('Minor reason')}
                            />
                            <Form.Radio
                                label="Not a reason"
                                checked={'Not a reason' === family}
                                value="Not a reason"
                                onClick={() => setFamily('Not a reason')}
                            />
                        </div>

                        {'Major reason' === family && (
                            <BarChart data={data.majorReasonFamily} />
                        )}
                        {'Minor reason' === family && (
                            <BarChart data={data.minorReasonFamily} />
                        )}
                        {'Not a reason' === family && (
                            <BarChart data={data.notReasonFamily} />
                        )}
                    </div>
                </section>
                <section id="discrimination-bigger-problem">
                    <p>
                        When asked which is the bigger problem when it comes to
                        discrimination against black people in our country,
                        slightly more blacks point to discrimination based on
                        the prejudice of individuals than to discrimination that
                        is built into laws and institutions. Opinion among
                        whites is more lopsided – a majority see individual
                        prejudice as a bigger problem while relatively few cite
                        institutional discrimination.
                    </p>
                    <div className="chart-container">
                        <h4 className="chart-title">
                            When it comes to discrimination against black people
                            in our country today, the bigger problem is ...
                        </h4>
                        <div className="radio-container">
                            <Form.Radio
                                label="Discrimination built into our laws and institutions"
                                checked={
                                    'Discrimination built into our laws and institutions' ===
                                    discrimination
                                }
                                value="Discrimination built into our laws and institutions"
                                onClick={() =>
                                    setDiscrimination(
                                        'Discrimination built into our laws and institutions',
                                    )
                                }
                            />
                            <Form.Radio
                                label="Discrimination based on prejudice of individuals"
                                checked={
                                    'Discrimination based on prejudice of individuals' ===
                                    discrimination
                                }
                                value="Discrimination based on prejudice of individuals"
                                onClick={() =>
                                    setDiscrimination(
                                        'Discrimination based on prejudice of individuals',
                                    )
                                }
                            />
                        </div>

                        {'Discrimination built into our laws and institutions' ===
                            discrimination && (
                            <BarChart data={data.discriminationInLaws} />
                        )}
                        {'Discrimination based on prejudice of individuals' ===
                            discrimination && (
                            <BarChart data={data.discriminationPrejudice} />
                        )}
                    </div>
                </section>
            </div>
        </>
    );
};

export default HoldingBackBlacks;
